"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var context = {
  zIndex: 2000
};
var _default = context;
exports["default"] = _default;